import { Button, Grid } from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  FormatListBulletedSharp as FormatListBulletedSharpIcon,
} from "@mui/icons-material";

type Props = {
  setData: (data: any) => void;
  data: any;
  edit?: boolean;
  del?: boolean;
  setShowModal?: (modal: "create" | "edit" | "delete" | "") => void;
  setDeleteModalData?: (data: { open: boolean; recipe: any }) => void; //for delete modal if needed in particular cases like in Recipes
  showContextMenu?: () => void;
};

export const GridButtonsV2 = ({
  setData,
  data,
  edit = true,
  del = true,
  setShowModal,
  setDeleteModalData,
  showContextMenu,
}: Props) => {
  const handleDeleteClick = () => {
    setData(data);

    if (setDeleteModalData) {
      setDeleteModalData({ open: true, recipe: data });
    } else if (setShowModal) {
      setShowModal("delete");
    }
  };

  return (
    <Grid
      container
      style={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="ag-grid-buttons"
    >
      <Grid
        item
        xs={12}
        md={12}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {edit && setShowModal && (
          <Button
            onClick={() => {
              setData(data);
              setShowModal("edit");
            }}
            title="Edit"
          >
            <EditIcon style={{ height: "auto" }} color="primary" />
          </Button>
        )}

        {del && (setDeleteModalData || setShowModal) && (
          <Button onClick={handleDeleteClick} title="Delete">
            <DeleteIcon style={{ height: "auto" }} color="secondary" />
          </Button>
        )}

        {showContextMenu && (
          <Button onClick={showContextMenu} title="Options">
            <FormatListBulletedSharpIcon
              style={{ height: "auto" }}
              color="action"
            />
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
